import { useSessionStore } from '../../shell/session/store/useSessionStore';
import { getOrganizationDisplayName } from '../../shell/navigation/organizationDisplayName';
import { getOrganizationEntitlementsCacheIfFresh } from '../../shell/feature-flags/planEntitlementsService';
import type { SaleReceiptBranding } from './buildSaleReceiptPayload';

export function resolveSaleReceiptBranding(branchId: string): SaleReceiptBranding {
  const state = useSessionStore.getState();
  const branch = state.branches.find((b) => b.id === branchId);
  const entitlements = getOrganizationEntitlementsCacheIfFresh();
  const orgName = getOrganizationDisplayName(entitlements ?? null);
  return {
    branchName: branch?.name?.trim() || 'Sucursal',
    organizationName: orgName,
  };
}
